import { FC } from 'react';
import Link from 'next/link';
import { useTranslation } from 'react-i18next';
import { BreadcrumbJsonLd } from 'next-seo';

import { canonicalLink } from 'utils/seo';
import { BreadcrumbWrapper, BreadcrumbList, BreadcrumbItem } from './styled';
import { DataAttributes, useTranslationEditorContext } from 'providers/TranslationEditor';

interface BreadcrumbElement {
  dataAttributes?: DataAttributes;
  title: string;
  path: string;
}

interface BreadcrumbProps {
  items: BreadcrumbElement[];
}

const Breadcrumb: FC<BreadcrumbProps> = ({ items }) => {
  const { t, i18n } = useTranslation();

  const { getDataAttributes } = useTranslationEditorContext();

  const home = {
    title: t('qr.breadcrumbs.home', 'MyQRCode QR Code Generator'),
    path: canonicalLink('', false, i18n.language),
    dataAttributes: getDataAttributes('qr.breadcrumbs.home'),
  };

  const breadcrumbItems = [home, ...items];

  const breadcrumbSchemaList = breadcrumbItems.map((item, index) => ({
    position: index + 1,
    name: item.title,
    item: item.path,
  }));

  return (
    <>
      <BreadcrumbJsonLd itemListElements={breadcrumbSchemaList} />
      <BreadcrumbWrapper aria-label="breadcrumb">
        <BreadcrumbList>
          {breadcrumbItems.map((item, index) => (
            <BreadcrumbItem key={item.title}>
              {index === breadcrumbItems.length - 1 ? (
                <span {...item.dataAttributes}>{item.title}</span>
              ) : (
                <Link {...item.dataAttributes} href={item.path}>
                  {item.title}
                </Link>
              )}
            </BreadcrumbItem>
          ))}
        </BreadcrumbList>
      </BreadcrumbWrapper>
    </>
  );
};

export default Breadcrumb;
